import { render, staticRenderFns } from "./AuthMain.vue?vue&type=template&id=6fecdc40&scoped=true"
import script from "./AuthMain.vue?vue&type=script&lang=js"
export * from "./AuthMain.vue?vue&type=script&lang=js"
import style0 from "./AuthMain.vue?vue&type=style&index=0&id=6fecdc40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fecdc40",
  null
  
)

export default component.exports